export default "__VITE_ASSET__CZ$hSgol__"